import React from "react"
import "./CookieMessage.css"
import CookieManager from "../../managers/CookieManager";


export default class CookieMessage extends React.Component {

    state = {
        accepted: false
    };

    onAcceptCookies() {
        CookieManager.cookieAccepted = 1;
        this.setState({
            accepted: true
        });
    }

    render() {
        if (CookieManager.cookieAccepted) {
            return null;
        }

        return (
            <div className="CookieMessageContainer">
                Please accept cookies for optimal performance.
                <u className="heavyText" onClick={() => this.onAcceptCookies()}>
                    Accept cookies
                </u>
            </div>
        )
    }
}